import { useState } from "react";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import CollectionReportTable from "./CollectionReportTable";
import type { TCollectionReport } from "./type/reportType";

const CollectionReport = () => {
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<TCollectionReport[]>({
		endPoint: "/api/admin/reports/collection-reports",
		queryKeys: ["collection-report"],
		params: {
			name: searchParams.name,
			status: searchParams.status,
			dateRange,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				showDateRange
				headerTitle='Collection Report List'
				handleSearchFun={(name) =>
					setSearchParams((prev) => ({ ...prev, name }))
				}
				handleDateRange={(date) => {
					setDateRange(date);
				}}
				handleSelectStatus={(status) =>
					setSearchParams((prev) => ({ ...prev, status }))
				}
				helmetTitle='BTTF - Collection Report list'
			>
				<CollectionReportTable
					data={data?.data || []}
					isLoading={isLoading}
				/>
			</CommCard>
		</>
	);
};
export default CollectionReport;
